import { TextField, Button, FormControl, FormLabel, Switch, FormControlLabel, MenuItem } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useState } from "react";

const ReportingForm = () => {
  const [reportingFormData, setReportingFormData] = useState({
    data_source: "",
    report_type: "",
    template_path: "",
    include_charts: false,
    include_summary: false,
    output_path: "",
  });

  const reportTypeOptions = ["PDF", "DOCX", "HTML", "JSON", "CSV"];

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setReportingFormData({
      ...reportingFormData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(reportingFormData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={3}>
        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Data Source</FormLabel>
            <TextField name="data_source" value={reportingFormData.data_source} onChange={handleChange} />
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Report Type</FormLabel>
            <TextField select name="report_type" value={reportingFormData.report_type} onChange={handleChange}>
              {reportTypeOptions.map((type) => (
                <MenuItem key={type} value={type}>
                  {type}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Template Path</FormLabel>
            <TextField name="template_path" value={reportingFormData.template_path} onChange={handleChange} />
          </FormControl>
        </Grid>

        <Grid size={6}>
          <FormControlLabel
            control={<Switch name="include_charts" checked={reportingFormData.include_charts} onChange={handleChange} />}
            label="Include Charts"
          />
        </Grid>

        <Grid size={6}>
          <FormControlLabel
            control={<Switch name="include_summary" checked={reportingFormData.include_summary} onChange={handleChange} />}
            label="Include Summary"
          />
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Output Path</FormLabel>
            <TextField name="output_path" value={reportingFormData.output_path} onChange={handleChange} />
          </FormControl>
        </Grid>

        <Grid size={12} textAlign="center">
          <Button variant="contained" color="primary" type="submit">
            Submit
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default ReportingForm;
